import styled from "styled-components";

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  h1 {
    font-weight: bold;
    text-align: center;
    font-size: 2rem;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem;

  header {
    h1 {
      font-size: 2rem;
      font-weight: bold;
    }
  }
`;

export const HistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  max-height: 100%;
  overflow-y: scroll;
  gap: 1rem;
  margin-top: 2rem;
`;

export const HistoryItem = styled.div`
  background: var(--black-100);
  padding: 1rem;
  border-radius: 0.35rem;
  width: 98%;
  display: grid;
  grid-template-columns: 0.7fr 1fr 1fr;

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0.6rem;
  }
`;

export const DateContainer = styled.div`
  flex-grow: min;
  padding-right: 0.7rem;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  border-right: 2px solid gray;

  p {
    background: var(--primary);
    color: var(--black-100);
    padding: 0.6rem 1rem;
    font-weight: bold;
  }
`;

export const ActionContainer = styled.div`
  height: 100%;
  flex-grow: 2;
  padding-left: 0.7rem;
  border-right: 2px solid gray;
  align-self: flex-start;

  p {
    &:first-of-type {
      color: #999797;
    }
  }
`;

export const AttendantContainer = styled.div`
  padding-left: 0.7rem;
  height: 100%;
  flex-grow: 2;
  align-self: flex-start;

  p {
    &:first-of-type {
      color: #999797;
    }
  }
`;
